// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import App from "./App";
import router from "./modules/router";
import axios from "axios";
import * as VueGoogleMaps from 'vue2-google-maps';
import AsyncComputed from 'vue-async-computed';
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "vue-prism-editor/dist/VuePrismEditor.css";
import store from './modules/store';
import VueBarcodeScanner from 'vue-barcode-scanner'
import VueQuagga from 'vue-quaggajs';
import VueSignature from 'vue-signature-pad';
import Vuebar from 'vuebar';
import JsonCSV from 'vue-json-csv'
import 'leaflet/dist/leaflet.css';

// import MultiFiltersPlugin from './plugins/MultiFilters'
// import MenuIcon from "vue-material-design-icons/Menu.vue"

const options = {
  theme: {
    dark: false,
    themes : {
      primary: "#00a7d3",
      secondary: "#1357a4",
      grey: "#424242",
      lightgrey: "#aeb8d6",
      black: "#323232",
      error: "#ff4d2b",
      dividerColor: "#42a5f5",
      cardColor: "#ECEFF1",
    }
  }
};

Vue.use(Vuetify);
// Vue.use(Vuebar);
Vue.use(VueSignature);
Vue.component('downloadCsv', JsonCSV)
Vue.use(VueQuagga);


// inject barcode scanner with option (add sound effect)
// sound will trigger when it's already scanned
let BarcodeScanner = {
  sound: true, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 300, // default is 100
  // requiredAttr: true // default is false
}

Vue.use(VueBarcodeScanner, BarcodeScanner)


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAK6Axa1wlFge65XFEdkKeev5TxuW3-1_s',
    libraries: 'places'
  },
});

Vue.use(AsyncComputed);

Vue.filter('currency', function (value) {
  const amt = Number(value);
  return amt && amt.toLocaleString(undefined, {style: "currency", currency: "AUD", currencyDisplay: "symbol", useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits:2}) || '0';
});

// Vue.component("prism-editor", VuePrismEditor);
// Vue.component("menu-icon", MenuIcon);

Vue.config.productionTip = process.env.NODE_ENV === "production";
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-API-KEY'] = store.store.state.auth.key;

new Vue({
  el: "#app",
  store: store.store,
  router: router.router,
  components: {App},
  template: "<App/>",
  vuetify: new Vuetify(options),
  created: function () {
    this.$store.dispatch('auth/authloop');
  }
});



// WEBPACK FOOTER //
// ./src/main.js